module.exports = __webpack_public_path__ + "img/h5img39.150fb440.png";